// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__269S_","actions":"GroupTable_actions__3RNNC","deleteModalFooter":"GroupTable_deleteModalFooter__3dR41"};